import { render } from "./DatadogEvent.vue?vue&type=template&id=410eadec&scoped=true"
import script from "./DatadogEvent.vue?vue&type=script&lang=js"
export * from "./DatadogEvent.vue?vue&type=script&lang=js"

import "./DatadogEvent.vue?vue&type=style&index=0&id=410eadec&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-410eadec"]])

export default __exports__